@if (listDocuments?.length > 0) {
  <div class="documents-list-group row">
    @if (name) {
      <h5 class="col-12 h-name">{{ name }}</h5>
    }
    <div class="col-md-4 no-pd" *ngFor="let document of listDocuments" (click)="openModalUpload(document)">
      <a
        [id]="'documentation-btn-upload-' + document?.name"
        href="javascript:;"
        class="document-box {{ document['classContent'] }}"
      >
        <div
          class="primary-info-box"
          [class.hasError]="document['hasError'] && document?.totalFiles === 0"
          [class.doc-not-mandatory]="!document?.mandatory"
        >
          <i class="ic {{ document['icon'] }}"></i>
          <h6>{{ 'documentation.name_' + document?.type | translate }}</h6>
          <p>{{ document['text'] }}</p>
          <!-- <p *ngFor="let reason of document.reasons">{{ reason }} </p> -->
        </div>
      </a>
    </div>
  </div>
}
